export enum EmptyStateSource {
  NoSearchResults = 'NoSearchResults',
  NoOffersAdded = 'NoOffersAdded',
}
